import $ from "jquery";

const elements = {
  $videoBlocks: $('.c-video')
};

function checkHeights(relatedElement, videoElement) {
  if ($(window).width() > 980) {
    relatedElement.css({'height':(videoElement.height() -50 +'px')});
  } 
}

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function init() {
  elements.$videoBlocks.each(function() {
    // get child elements for instance of video block
    const videoBlockElements = {
      $thumbnails: $(this).find(".js-video-thumbnails"),
      $iframe: $(this).find(".js-video-iframe"),
      $text: $(this).find(".c-video-container__caption--js-text"),
      $related: $(this).find(".c-video-related"),
    };

    // loops over thumbnails and attach click event
    videoBlockElements.$thumbnails.each(function(){
      var iframeSource = $(this).attr("data-iframe-source");
      var dataThumbnailDescription= $(this).attr('data-thumbnail-description');
      var dataThumbnailTitle= $(this).attr('data-thumbnail-title');
  
      $(this).click(function(){
        videoBlockElements.$iframe.attr("src", iframeSource);
        videoBlockElements.$text.text(dataThumbnailDescription);
        videoBlockElements.$iframe.attr("title", dataThumbnailTitle)
      })
    })

    // set up debounced height check
    var debounceHeightCheck = debounce(function() {
      checkHeights(videoBlockElements.$related, videoBlockElements.$iframe)
    }, 250);

    // on window size change set height
    window.addEventListener('resize', debounceHeightCheck);
    
    // on init set height
    checkHeights(videoBlockElements.$related, videoBlockElements.$iframe);
  })
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/video/video-thumbnails.js